// The harness `RunTransport` ASSEMBLY, unchanged in shape: six plain HTTP
// members composed from `/data`, plus the three that resolve the ml-scribe
// origin and mint auth/identity headers. Those three are why the module was
// app-side; they read `resolveApiOrigin` / `getClientHeaders` /
// `getAuthTokenSync` per call inside the closures below, so nothing here runs
// at import time. See the `agent-harness` block in the `.` door for the intake.
//
// HISTORY POINTER. `git log --follow` does NOT reach past the move for this file
// at git's default 50% similarity: the port rewrite replaced most of a small
// module, so the rename scores below the threshold. Either of these works:
//
//   git log --follow -M20% -- src/features/agent-harness/client.ts
//   git log -- src/features/agent-harness/client.ts
import type { RunTransport } from '../../contracts';
import { agentHarnessRunEventsPath, agentHarnessRunStreamPath } from '../../contracts';
import {
  attachmentDownloadUrl,
  attachmentPreviewBlob,
  cancelTurn,
  getRun,
  resolveApproval,
  submitTurn,
} from '../../data';
import { streamHeaders } from './stream/stream-http';
import { agentHarnessUrl } from './url';

export { setAgentRunApprovalMode } from '../../data';

export const agentHarnessClient: RunTransport = {
  capabilities: { attachments: false },

  getRun,
  submitTurn,
  cancelTurn,
  resolveApproval,
  attachmentDownloadUrl,
  attachmentPreviewBlob,

  streamPath: (agentRunId: string) =>
    agentHarnessUrl(agentHarnessRunStreamPath(agentRunId)),

  eventsPath: (agentRunId: string) =>
    agentHarnessUrl(agentHarnessRunEventsPath(agentRunId)),

  streamHeaders,
};
